import { xUnits } from '../../../UNSAFE_Theme/utils';

export const scaleSchemeLg = {
  iconSize: '',
  sizes: {
    xs: {
      iconSize: 'max(' + xUnits(5) + ', 20px)'
    },
    sm: {
      iconSize: xUnits(5)
    },
    md: {
      iconSize: xUnits(6)
    },
    lg: {
      iconSize: xUnits(6)
    },
    embeddedxs: {
      iconSize: 'max(' + xUnits(5) + ', 20px)'
    },
    embeddedsm: {
      iconSize: xUnits(5)
    },
    embeddedmd: {
      iconSize: xUnits(6)
    },
    embeddedlg: {
      iconSize: xUnits(6)
    }
  }
};
